/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: () => ({
        savedCardWrapper: {
            columns: [1, 1, 2],
            spacing: 4,
            gridAutoFlow: 'row dense'
        },
        addNewCardBtn: {
            variant: 'outline',
            border: '1px dashed',
            borderColor: 'gray.200',
            color: 'blue.600',
            height: ['20px', '20px', '92px'],
            rounded: 'base',
            fontWeight: 'medium'
        },
        appliedPaymentRemoveBtn: {
            size: 'sm',
            colorScheme: 'red',
            variant: 'link'
        },
        savedCard: {
            padding: 0,
            border: 'none'
        },
        ccFormWrapper: {
            border: '1px solid',
            borderColor: 'gray.100',
            rounded: 'base',
            overflow: 'hidden'
        },
        ccFormHeadingWrapper: {
            py: 3,
            px: [4, 4, 6],
            bg: 'gray.50',
            borderBottom: '1px solid',
            borderColor: 'gray.100'
        },
        ccFormInputWrapper: {
            p: [4, 4, 6],
            borderBottom: '1px solid',
            borderColor: 'gray.100'
        },
        ccFormInputStack: {
            spacing: 6,
            borderWidth: '2px',
            borderColor: 'gray.400'
        }
    })
}
